export type ISelectAllChildNodes = (node: any) => void;

export function selectAllChildNodes(node: any): void {
  const { selected } = node;
  if (node.hasChildren()) {
    $.each(node.getChildren(), (_, childNode) => {
      childNode.setSelected(selected);
      childNode.makeVisible();
    });
  }
}
